export default __webpack_public_path__ + "static/media/jQuery_Certificate.31661373.png";